import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App.jsx';            // your admin dashboard UI (already built)
import Login from './ui/login.jsx';     // we’ll add this file below
import './index.css';

function RequireAuth({ children }) {
    // token presence check; backend validation happens in App boot (AuthAPI.me)
    const token = localStorage.getItem('token');
    if (!token) return <Navigate to="/login" replace />;
    return children;
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter>
        <Routes>
            {/* default route -> protected app; redirects to /login if not authed */}
            <Route
                path="/*"
                element={
                    <RequireAuth>
                        <App />
                    </RequireAuth>
                }
            />
            <Route path="/login" element={<Login />} />
        </Routes>
    </BrowserRouter>
);
